<template>
  <div class="page event-management">
    <management-nav></management-nav>
    <side-menu activeNav="Event" childName="Reports"> </side-menu>

    <div class="content">
      <div class="dashboard">
        <heading v-if="event" title="Reports"></heading>
      </div>

      <div class="selector-search-reports">
        <label>Report Type:</label>
        <v-select
          :options="reportTypes"
          id="selector-inp"
          v-model="selectedOptions"
          @input="filterByTicket"
          label="name"
        />
      </div>

      <div class="selector-search-reports">
        <label>Date Range:</label>
        <v-select
          id="selector-inp"
          @input="filterByTicket"
          label="name"
          :options="ticket_options"
        />
      </div>

      <div class="selector-search-reports">
        <label>Attendee Status:</label>
        <v-select
          id="selector-inp"
          @input="filterByTicket"
          label="name"
          :options="ticket_options"
        />
      </div>

      <div class="selector-search-reports">
        <label>Attendee Status:</label>
        <input class="search-inp" type="text" placeholder="Search Attendees" />
      </div>

      <div class="export_report">
        <h3>Report Results</h3>
        <label>Export:</label>
        <div class="export_btn">
          <button @click="exportCSV" class="btn">Excel</button>
          <button @click="exportCSV" class="btn">CSV</button>
        </div>
      </div>

      <div class="summary_table">
        <div :style="{ display: 'flex', flexDirection: 'column' }">
          <span>Total Sales: ${{ this.analytics.gross_amount }}</span>
          <span>Total Orders: {{ this.orders.length }}</span>
          <span>Total Attendees: {{ this.guests.length }}</span>
        </div>

        <table>
          <thead>
            <td>Order #</td>
            <td>Order Date</td>
            <td>Name</td>
            <td>Email</td>
            <td>Quantity</td>
            <td>Ticket Type</td>
            <!-- <td>Order Type</td> -->
            <td>Total Paid</td>
            <td>Event Fees</td>
            <td>Payment Processing</td>
            <td>Attendee Status</td>
            <td>Home Address 1</td>
            <td>Home Address 2</td>
            <td>City</td>
            <td>State</td>
            <td>Zip</td>
            <td>Country</td>
            <td>Billing Address 1</td>
            <td>Billing Address 2</td>
            <td>Billing City</td>
            <td>Billing State</td>
            <td>Billing Zip</td>
            <td>Billing Country</td>
          </thead>

          <tbody>
            <tr v-for="(item, index) in line_items" :key="index">
              <td>{{ item.order_number }}</td>
              <td>{{ item.created_at | format_date_time }}</td>
              <td>{{ item.buyer }}</td>
              <td>{{ item.email }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ item.name }}</td>
              <td>{{ item.total_price }}</td>
              <td>{{ "n/a" }}</td>
              <td>{{ "n/a" }}</td>
              <td>{{ "n/a" }}</td>
              <td>
                {{ item.address.address_1 }}
              </td>
              <td>
                {{ item.address.address_2 }}
              </td>
              <td>
                {{ item.address.city }}
              </td>
              <td>
                {{ item.address.state }}
              </td>
              <td>
                {{ item.address.zip }}
              </td>
              <td>
                {{ item.address.country }}
              </td>
              <td>
                {{ item.billing.address_1 }}
              </td>
              <td>
                {{ item.billing.address_2 }}
              </td>
              <td>
                {{ item.billing.city }}
              </td>
              <td>
                {{ item.billing.state }}
              </td>
              <td>
                {{ item.billing.zip }}
              </td>
              <td>
                {{ item.billing.country }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import BtnNav from "@/components/BtnNav.vue";
import managementBar from "@/components/managementBar.vue";
import managementMenu from "@/components/managementMenu.vue";
import Title from "@/components/Title.vue";

const fb = require("../firebaseConfig.js");
const db = fb.default.db;
var moment = require("moment");

export default {
  name: "events",
  components: {
    "btn-nav": BtnNav,
    "management-nav": managementBar,
    "side-menu": managementMenu,
    heading: Title,
  },
  data() {
    return {
      event: null,
      analytics: {},
      selectedOptions: { name: "Attendees Summary", id: 1 },
      ticket_options: [],
      tickets: [],
      progress: "0%",
      reports: [],
      line_items: [],
      orders: [],
      guests: [],
      reportTypes: [
        { name: "Attendees Summary", id: 1 },
        { name: "Sales by Ticket Type", id: 2 },
        { name: "Total Revenue Generated", id: 3 },
        { name: "Sales by Ticket Type", id: 4 },
        { name: "Sales Summary", id: 5 },
        { name: "Check-In Summary", id: 6 },
      ],
    };
  },
  firestore() {
    return {
      event: db.collection("event").doc(this.$route.params.id),
      analytics: db.collection("event_analytics").doc(this.$route.params.id),
      tickets: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("ticket"),
      orders: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("orders"),
      guests: db
        .collection("event")
        .doc(this.$route.params.id)
        .collection("guest"),
    };
  },
  watch: {
    orders() {
      this.getAttendeesSummary();
    },
  },
  methods: {
    filterByTicket(type) {
      if (type.id == 1) {
        this.reports = this.tickets;
      }
    },
    getAttendeesSummary() {
      this.orders.forEach(async (order) => {
        let items = await db
          .collection("event")
          .doc(this.$route.params.id)
          .collection("orders")
          .doc(order.id)
          .collection("line_items")
          .get();
        let buyer = await db.doc(order.buyer_path).get();

        let line_items = items.docs.map((doc) =>
          Object.assign(
            {
              id: doc.id,
              order_id: order.id,
              order_number: order.order_number,
              buyer: order.payment_info.name,
              email: buyer.data().email,
              address: buyer.data().address ? buyer.data().address : {},
              billing: order.billing_address,
            },
            doc.data()
          )
        );
        this.line_items = [].concat(this.line_items, line_items);
        console.log("line_items", this.line_items);
      });
    },
    exportCSV() {},
  },
};
</script>

<style lang="scss"></style>
